export const buttonCommon = `inline-block border border-uhblue px-2 py-1 rounded text-center \
center cursor-pointer font-bold relative `;
export const blueButton = `blue bg-uhblue hover:bg-uhblue-dark  text-white`;
export const outlineButton = `bg-white hover:bg-uhblue-light text-uhblue`;
export const iconClasses = `text-uhblue-darkest inline-block cursor-pointer ml-2 h-5 w-5 inline-block`